import { Helmet } from 'react-helmet';

import {
  getAdobeAnalyticsLayer,
  getAdobeAnalyticsLibrary,
  getAdobeAnalyticsPlugin,
  getDsmTokens,
} from '../env-vars';

export default function AppHelmet() {
  return (
    <Helmet
      script={[
        {
          src: getAdobeAnalyticsLibrary(),
          type: 'text/javascript',
          async: true,
        },
        {
          src: getAdobeAnalyticsPlugin(),
          type: 'text/javascript',
          async: true,
        },
        {
          src: getAdobeAnalyticsLayer(),
          type: 'text/javascript',
          async: true,
        },
      ]}
    >
      <link
        rel="stylesheet"
        href={getDsmTokens()}
        type="text/css"
        media="all"
      />
    </Helmet>
  );
}
